import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { BasketLine } from '../_models/basketline';
import { Order } from '../_models/order';
import { OrderService } from '../_services/order.service';

@Component({
    selector: 'app-orderhistory',
    templateUrl: './orderhistory.component.html',
    styleUrls: ['./orderhistory.component.css'],
    standalone: false
})
export class OrderhistoryComponent implements OnInit {
  orders$: Observable<Order[]>;
  orderlines$: Observable<BasketLine[]>;
  searchForm: FormGroup;
  selectedOrderReference: string;
  toonNoOrder: boolean;
  toonDetailsOrder: boolean;
  selectedOrder: Order;
  total: number;
  
  constructor(private orderService: OrderService, private fb: FormBuilder) { }

  ngOnInit(): void {
    this.initializeForm();
    this.load();
  }

  initializeForm(){
    
    this.searchForm = this.fb.group({
      
    })
  }

  load()  {
    this.orders$ = this.orderService.getAll();
  }  


  search()  {
    this.toonNoOrder = false;
    this.toonDetailsOrder = false;
    if (this.selectedOrderReference == null || this.selectedOrderReference.length == 0)
    {
      this.toonNoOrder = true;
      return;
    }
    
    this.orders$.subscribe(orders => { 
      orders.forEach(order => {
        if (order.orderReference == this.selectedOrderReference)
        {
          this.selectedOrder = order;
        }
      });
    });    
    this.orderlines$ = this.orderService.getOrderLines(this.selectedOrderReference);
    this.getTotal();
    this.toonDetailsOrder = true;
  }

  getTotal(){
    this.total = 0;
    this.orderlines$.subscribe(lines => { 
      lines.forEach(e => {
        this.total = this.total + (e.aantal * e.verkoopprijs);
      })
    });
  }

}
